import React, { useState } from 'react';
import { Mail, Phone, Clock, MapPin, Send, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import EditableText from '../components/EditableText';
import { useCMS } from '../context/CMSContext';

const ContactPage = () => {
  const { t } = useCMS();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    toast.success('Message sent! We\u2019ll reply within 1 business day.');
    setSent(true);
    setForm({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSent(false), 3000);
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <main className="max-w-6xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <EditableText k="contact.title" as="h1" className="text-[#0a0a0a] font-bold text-4xl md:text-5xl tracking-tight" fallback="Contact Us" />
          <EditableText k="contact.subtitle" as="p" multiline className="text-slate-500 mt-4 leading-relaxed"
            fallback="Questions about a product, order, or COA? Our team is based in Australia and responds within one business day." />

          <div className="mt-10 space-y-6">
            <ContactRow Icon={Mail} label="Email" k="footer.email" fallback="support@peptihub.com" />
            <ContactRow Icon={Phone} label="Phone" k="footer.phone" fallback="(03) 9355 9001" />
            <ContactRow Icon={Clock} label="Hours" k="footer.hours" fallback="Mon – Fri, 9AM – 5PM AEST" />
            <ContactRow Icon={MapPin} label="Address" k="contact.address" fallback="Vitality Health Plus FZE LLC, Melbourne VIC" />
          </div>
        </div>

        <div className="lg:col-span-3 bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <form onSubmit={submit} className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <FormField label="Name"><input required value={form.name} onChange={set('name')} className="input" /></FormField>
              <FormField label="Email"><input required type="email" value={form.email} onChange={set('email')} className="input" /></FormField>
            </div>
            <FormField label="Subject"><input required value={form.subject} onChange={set('subject')} className="input" /></FormField>
            <FormField label="Message"><textarea required rows={6} value={form.message} onChange={set('message')} className="input resize-none" /></FormField>
            <button type="submit" className="inline-flex items-center gap-2 px-6 py-3 bg-red-500 hover:bg-red-400 text-white font-semibold rounded-lg transition-colors">
              {sent ? <><CheckCircle2 size={16} /> Sent</> : <><Send size={16} /> Send Message</>}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

const ContactRow = ({ Icon, label, k, fallback }) => (
  <div className="flex gap-4">
    <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-red-50 flex items-center justify-center"><Icon size={18} className="text-red-600" strokeWidth={1.75} /></div>
    <div>
      <div className="text-xs font-semibold tracking-[0.12em] uppercase text-slate-500">{label}</div>
      <EditableText k={k} className="text-[#0a0a0a] font-medium" fallback={fallback} />
    </div>
  </div>
);

const FormField = ({ label, children }) => (
  <label className="block">
    <span className="block text-sm font-medium text-slate-700 mb-1.5">{label}</span>
    {children}
  </label>
);

export default ContactPage;
